import mondaySdk from 'monday-sdk-js';
import { MondayClientSdk } from 'monday-sdk-js/types/client-sdk.interface';

let monday: MondayClientSdk;

function isMondayPlatform(): boolean {
  return process.env.REACT_APP_HOST_PLATFORM === 'monday';
}

if (isMondayPlatform()) {
  monday = mondaySdk();
  monday.setApiVersion('2023-10');
}

export { monday };
